import fetch from 'isomorphic-unfetch';
import getConfig from 'next/config';

const { publicRuntimeConfig: features } = getConfig();

const fetcher = (...args) =>
  fetch(...args)
    .then((r) => {
      if (r.ok) {
        return r.json();
      }
      throw new Error(`Received error fetching compare data: ${r.status}`);
    })
    .catch((e) => {
      throw new Error(e);
    });

export const PATH = `${features.applicationPrefix}/api/compare`;

export const fetchCompareData = (products) => fetcher(`${PATH}/${products}`);
